/* header=》设置=》镜像管理接口数据 */

import axios from 'axios'
import { ihupgradeUrl, baseUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

// 分页查询镜像
export function getUpgradeimg(params) {
  const url = ihupgradeUrl + '/upgradeimg'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('镜像管理', '分页查询镜像', res)
    }
    return Promise.resolve(res.data)
  })
}
// 新增镜像,config:作用于进度条
export function addUpgradeimg(params, config) {
  const url = ihupgradeUrl + '/upgradeimg'
  let axiosConfig = {
    url: url,
    method: 'post',
    data: params,
  }
  if (config instanceof Object) {
    for (let key in config) {
      axiosConfig[key] = config[key]
    }
  }
  return axios(axiosConfig).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('镜像管理', '新增镜像,config:作用于进度条', res)
    }
    return Promise.resolve(res.data)
  })
}
// 更新镜像
export function editUpgradeimg(params, config) {
  const url = ihupgradeUrl + '/upgradeimg'
  let editAxiosConfig = {
    url: url,
    method: 'put',
    data: params,
  }
  if (config instanceof Object) {
    for (let key in config) {
      editAxiosConfig[key] = config[key]
    }
  }
  return axios(editAxiosConfig).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('镜像管理', '更新镜像', res)
    }
    return Promise.resolve(res.data)
  })
}
// 删除镜像
export function deleteUpgradeimg(params) {
  const url = ihupgradeUrl + '/upgradeimg'
  return axios({
    method: 'delete',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('镜像管理', '删除镜像', res)
    }
    return Promise.resolve(res.data)
  })
}
// 上传镜像检查
export function checkupgradeimg(params) {
  const url = ihupgradeUrl + '/checkupgradeimg'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('镜像管理', '上传镜像检查', res)
    }
    return Promise.resolve(res.data)
  })
}
// 获取所有租户根组织架构数据
export function orgunitRootList(params) {
  const url = baseUrl + '/orgunit/root/list'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('镜像管理', '获取所有租户根组织架构数据', res)
    }
    return Promise.resolve(res.data)
  })
}

// 分页查询批次
export function getUpgradebatch(params) {
  const url = ihupgradeUrl + '/upgradebatch'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('镜像管理', '分页查询批次', res)
    }
    return Promise.resolve(res.data)
  })
}
// 新增批次
export function addUpgradebatch(params) {
  const url = ihupgradeUrl + '/upgradebatch'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('镜像管理', '新增批次', res)
    }
    return Promise.resolve(res.data)
  })
}
// 更新批次
export function editUpgradebatch(params) {
  const url = ihupgradeUrl + '/upgradebatch'
  return axios({
    method: 'put',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('镜像管理', '更新批次', res)
    }
    return Promise.resolve(res.data)
  })
}
// 删除批次
export function deleteUpgradebatch(params) {
  const url = ihupgradeUrl + '/upgradebatch'
  return axios({
    method: 'delete',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('镜像管理', '删除批次', res)
    }
    return Promise.resolve(res.data)
  })
}

// 获取所有租户根组织架构数据
export function orgunitRootTree(params) {
  const url = baseUrl + '/orgunit/root/deviceType/tree'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(result => {
    if (result.status !== 200 || (!!result.data && result.data.state !== 0)) {
      errorCollection('镜像管理', '获取所有租户根组织架构数据', result)
    }
    return Promise.resolve(result.data)
  })
}
export function queryOuByCheck(params) {
  const url = ihupgradeUrl + '/queryOuByCheck'
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('镜像管理', '检查机构', res)
    }
    return Promise.resolve(res.data)
  })
}
